import { CheckIcon, ClipboardDocumentIcon } from '@heroicons/react/20/solid';
import React from 'react';

import { AnimatePresence, FadeIn, ScaleSwap } from './Animations';
import { cn } from './cn';

export interface CodeBlockProps {
  children: string;
  showCopyButton?: boolean;
  className?: string;
}

export const CodeBlock = ({ children, showCopyButton = false, className }: CodeBlockProps) => {
  const [copied, setCopied] = React.useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(children);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <FadeIn className={cn('relative rounded-lg bg-gray-100 p-4', className)}>
      {showCopyButton && (
        <button
          onClick={handleCopy}
          className="absolute top-2.5 right-2.5 inline-flex items-center rounded-md p-1.5 text-gray-400 hover:text-gray-700 hover:bg-gray-200 transition-all duration-200 cursor-pointer bg-transparent border-none"
          title="Copy code"
        >
          <AnimatePresence mode="wait">
            {copied ? (
              <ScaleSwap key="check">
                <CheckIcon className="h-4 w-4 text-success-500" />
              </ScaleSwap>
            ) : (
              <ScaleSwap key="copy">
                <ClipboardDocumentIcon className="h-4 w-4" />
              </ScaleSwap>
            )}
          </AnimatePresence>
        </button>
      )}
      <pre className="m-0 overflow-x-auto text-xs font-mono text-gray-800 whitespace-pre-wrap leading-relaxed">
        {children}
      </pre>
    </FadeIn>
  );
};
